import React from 'react'

const PrivacyPolicyPage = () => {
  return (
    <div className='min-h-screen bg-gray-100 p-6 flex flex-col items-center'>
      <section
        id='privacy-policy'
        className='px-6 py-12 max-w-4xl mx-auto bg-white rounded-lg shadow-lg'
      >
        <h1 className='text-3xl font-bold mb-6 text-center'>
          Politique de Confidentialité – Voyo 🐦
        </h1>

        <p className='mb-6'>
          Bienvenue sur Voyo ! Chez Voyo, votre vie privée est importante pour nous. Nous vous
          expliquons ici quelles données nous collectons, pourquoi et comment elles sont protégées.
        </p>

        <div className='space-y-4'>
          {/* 1. Définitions */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>1. Définitions</summary>
            <ul className='mt-2 list-disc list-inside'>
              <li>
                <strong>L&apos;Éditeur :</strong> la personne physique ou morale qui édite les
                services Voyo.
              </li>
              <li>
                <strong>Voyo :</strong> l&apos;ensemble des sites, pages internet et services en
                ligne proposés par l&apos;Éditeur.
              </li>
              <li>
                <strong>Visiteur :</strong> la personne proposant ses services contre rémunération.
              </li>
              <li>
                <strong>Mandant :</strong> la personne qui utilise Voyo pour déléguer une visite à
                un bien à louer.
              </li>
            </ul>
          </details>

          {/* 2. Données collectées */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>
              2. Quelles données nous collectons et pourquoi
            </summary>
            <h4 className='font-semibold mt-2'>2.1 Données nécessaires pour utiliser Voyo</h4>
            <ul className='list-disc list-inside mt-2'>
              <li>
                <strong>Mandant :</strong> nom, prénom, email (facultatif : ville, date de
                naissance, téléphone)
              </li>
              <li>
                <strong>Visiteur :</strong> nom, prénom, ville, date de naissance, email, téléphone,
                numéro fiscal. Vérification via Stripe.
              </li>
              <li>
                <strong>Recherches :</strong> zone géographique, date
              </li>
              <li>
                <strong>Mots de passe :</strong> cryptés, non accessibles par Voyo
              </li>
              <li>
                <strong>Paiements :</strong> via Stripe, informations bancaires
                <strong>jamais stockées sur Voyo</strong>
              </li>
            </ul>
            <h4 className='font-semibold mt-4'>2.2 Pourquoi nous collectons ces données</h4>
            <ul className='list-disc list-inside mt-2'>
              <li>Gérer vos comptes et accès à Voyo</li>
              <li>Gérer vos réservations</li>
              <li>Répondre à vos demandes et améliorer nos services</li>
              <li>Prévenir la fraude et protéger nos utilisateurs</li>
              <li>Répondre aux obligations fiscales</li>
            </ul>
          </details>

          {/* 3. Partage des données */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>
              3. À qui vos données peuvent être transmises
            </summary>
            <ul className='list-disc list-inside mt-2'>
              <li>
                <strong>Visiteurs / Mandants :</strong> uniquement les informations nécessaires pour
                communiquer sur la plateforme
              </li>
              <li>
                <strong>Autorités légales :</strong> si la loi l&apos;exige
              </li>
              <li>
                <strong>Transfert d&apos;entreprise :</strong> en cas de fusion, vente ou
                acquisition de Voyo
              </li>
            </ul>
          </details>

          {/* 4. Messagerie */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>4. Messagerie intégrée</summary>
            <p className='mt-2'>
              Nous analysons automatiquement le contenu des messages pour détecter les spams,
              fraudes ou logiciels malveillants.
            </p>
          </details>

          {/* 5. Données techniques */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>5. Données techniques</summary>
            <p className='mt-2'>
              Nous <strong>ne collectons pas vos données techniques identifiables</strong> (IP,
              fournisseur d&apos;accès, terminal). Pour les statistiques, seules des informations
              anonymisées peuvent être utilisées.
            </p>
          </details>

          {/* 6. Cookies */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>6. Cookies</summary>
            <p className='mt-2'>
              Durée maximale : 13 mois. Finalité : statistiques, personnalisation, amélioration du
              service. Vous pouvez refuser les cookies via votre navigateur.
            </p>
          </details>

          {/* 7. Conservation et anonymisation */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>
              7. Conservation et anonymisation des données
            </summary>
            <ul className='list-disc list-inside mt-2'>
              <li>Pendant la relation contractuelle : données conservées le temps nécessaire</li>
              <li>Après suppression du compte : données anonymisées pour statistiques</li>
              <li>3 ans d&apos;inactivité : un email est envoyé, puis suppression automatique</li>
            </ul>
          </details>

          {/* 8. Suppression du compte */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>8. Suppression du compte</summary>
            <ul className='list-disc list-inside mt-2'>
              <li>Vous pouvez supprimer votre compte à tout moment</li>
              <li>Violation de la politique : Voyo peut restreindre ou supprimer le compte</li>
            </ul>
          </details>

          {/* 9. Transfert hors UE */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>
              9. Transfert de données hors UE
            </summary>
            <p className='mt-2'>
              Aucun transfert en dehors de l&apos;Union européenne sans votre consentement.
            </p>
          </details>

          {/* 10. Modifications */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>
              10. Modifications de la politique
            </summary>
            <p className='mt-2'>
              Toute modification substantielle sera communiquée par email ou notification. Votre
              consentement sera demandé si le niveau de confidentialité change.
            </p>
          </details>

          {/* 11. Portabilité */}
          <details className='border rounded p-4'>
            <summary className='font-semibold cursor-pointer'>11. Portabilité</summary>
            <p className='mt-2'>
              Vous pouvez demander une copie complète de vos données dans un format réutilisable.
            </p>
          </details>
        </div>

        <p className='mt-8 text-center text-gray-600'>
          Votre vie privée est notre priorité chez Voyo 🐦
        </p>
      </section>

      {/* Optional CSS for smooth expand/collapse */}
      <style>{`
        details[open] summary::after {
          content: "▲";
          float: right;
        }
        summary::after {
          content: "▼";
          float: right;
        }
        summary {
          outline: none;
        }
      `}</style>
    </div>
  )
}

export default PrivacyPolicyPage
